// This process is selected when backend replyProcessFlow is
// "received-request-reply". Legacy "default" remains a separate flow.
const receivedRequestReplyManifest = Object.freeze({
    schemaVersion: 1,
    id: 'received-request-reply',
    version: 1,
    title: 'Standard received request reply process',
    settings: {
        renderer: 'horizontal-stepper',
        rendererSettings: {
            contentContainer: 'card',
            showStepTitle: true,
            showStepDescription: true,
            showPreviousButton: true,
            contentBordered: true,
            stepperSize: 'md',
            saveStatus: 'header',
            showSaveStatusText: false,
        },
        accordion: true,
        showStepNumbers: true,
        revealMode: 'all',
        navigation: {
            scrollOnOpen: 'start',
            blockForwardOnInvalidSteps: true,
        },
        progressPersistenceMode: 'background',
        initialStepMode: 'resume',
    },
    steps: [
        {
            id: 'general-product-information',
            type: 'general-product-information',
            typeVersion: 2,
            order: 10,
            enabled: true,
            titleOverride: null,
            navigationTitleOverride: null,
            descriptionOverride: null,
            numbered: true,
            review: {
                enabled: true,
                initiallyExpanded: false,
                icon: 'BoxIcon',
            },
            settings: {
                sections: [
                    'identity',
                    'product-weight',
                ],
                showCustomerProductName: true,
                showCustomerProductIdentifier: true,
                showCustomerProductDescription: true,
                showCustomerProductReferenceOnlyWhenDifferent: true,
            },
            availability: {
                visibleWhen: null,
                disabledWhen: null,
            },
            validation: {
                mode: 'component',
            },
            completion: {
                mode: 'button',
            },
            mount: {
                mode: 'eager',
            },
            navigation: {
                unavailableBehavior: 'skip',
            },
            legacy: {
                persistedStep: 1,
            },
        },
        {
            id: 'request-handling',
            type: 'request-handling',
            typeVersion: 1,
            order: 20,
            enabled: true,
            titleOverride: null,
            descriptionOverride: null,
            numbered: true,
            review: {
                enabled: true,
                initiallyExpanded: false,
                icon: 'UserIcon',
            },
            settings: {
                showOptionDescriptions: true,
                showProductSupplierDetails: true,
                showProductStructure: true,
                showForwardedRequests: true,
                bulkAllowedStrategies: [
                    'answer-request-directly',
                ],
                productStructure: {
                    mode: 'top-down',
                    showModeSelector: false,
                    requireAtLeastOneComponent: true,
                },
            },
            availability: {
                visibleWhen: null,
                disabledWhen: null,
            },
            validation: {
                mode: 'component',
            },
            completion: {
                mode: 'button',
            },
            mount: {
                mode: 'eager',
            },
            navigation: {
                unavailableBehavior: 'skip',
            },
            legacy: {
                persistedStep: 10,
            },
        },
        {
            id: 'documents-and-webpages',
            type: 'documents-and-webpages',
            typeVersion: 1,
            order: 30,
            enabled: true,
            titleOverride: null,
            navigationTitleOverride: null,
            descriptionOverride: null,
            numbered: true,
            review: {
                enabled: true,
                initiallyExpanded: false,
                icon: 'FileTextIcon',
            },
            settings: {
                acceptedExtensions: ['pdf'],
                multipleFiles: true,
                showWebpageLinks: true,
                reviewProfile: 'received-request-guided-document-review',
                researchReviewProfile: 'received-request-guided-document-research-review',
                productLookupMode: 'organization-products',
            },
            availability: {
                visibleWhen: null,
                disabledWhen: null,
            },
            validation: {
                mode: 'component',
            },
            completion: {
                mode: 'button',
            },
            mount: {
                mode: 'when-reachable',
            },
            navigation: {
                unavailableBehavior: 'skip',
            },
            legacy: {
                persistedStep: 11,
            },
        },
        {
            id: 'compliance-information',
            type: 'compliance-information',
            typeVersion: 2,
            order: 40,
            enabled: true,
            titleOverride: null,
            descriptionOverride: null,
            numbered: true,
            review: {
                enabled: true,
                initiallyExpanded: false,
                icon: 'ShieldIcon',
            },
            settings: {
                showSummary: true,
                enableScipNumber: true,
                scipNumberRequired: true,
                hideCandidateListCategoriesWhenScipProvided: true,
                showRequirementsHeading: false,
                showSubstanceRequirementStatus: true,
                requireCompleteInformation: false,
                simpleOverview: {
                    requirementDisplay: 'collapsible',
                },
                substanceComponent: 'SubstanceV4',
            },
            availability: {
                visibleWhen: null,
                disabledWhen: null,
            },
            validation: {
                mode: 'component',
            },
            completion: {
                mode: 'button',
            },
            mount: {
                mode: 'when-reachable',
            },
            navigation: {
                unavailableBehavior: 'skip',
            },
            legacy: {
                persistedStep: 12,
            },
        },
        {
            id: 'review-and-submit',
            type: 'review-and-submit',
            typeVersion: 1,
            order: 50,
            enabled: true,
            titleOverride: null,
            navigationTitleOverride: null,
            descriptionOverride: null,
            numbered: false,
            settings: {
                showWorkflowReview: true,
                showDeclarationDetails: true,
                showIdentityConfirmation: true,
                validityRequired: true,
                requireAuthorization: true,
                showInformationReuseConsent: true,
                keepContentAfterSubmit: true,
                allowResubmission: true,
                showSubmittedAt: true,
            },
            availability: {
                visibleWhen: null,
                disabledWhen: null,
            },
            validation: {
                mode: 'none',
            },
            completion: {
                mode: 'terminal',
                persistProgress: false,
                validationScope: 'all',
                invalidBehavior: 'review-summary',
                scrollAfterExecution: true,
            },
            mount: {
                mode: 'when-reachable',
            },
            navigation: {
                unavailableBehavior: 'skip',
            },
        },
    ],
})

export { receivedRequestReplyManifest }
export default receivedRequestReplyManifest
